export { default } from './PauseHoldButton';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/PauseHoldButton/index.js